import { CookieConsentProps } from '../cookieConsent.props'

export const data: CookieConsentProps = {
  isEnabled: true,
  basic: {
    label: 'Cookie Settings',
    url: '/cookies',
    description:
      '„Бисквитките“ ни помагат да подобрим нашите услуги. Разглеждайки съдържанието на сайта, Вие се съгласявате и с използването на „бисквитки“',
    agree: 'ОК',
    configure: 'Управление на настройките',
  },
  advanced: {
    moreInfo: 'Детайлна информация',
    acceptAll: 'Приеми всички',
    saveChanges: 'Запази промените',
  },
  details: {
    table: {
      source: 'Източник',
      name: 'Име',
      purpose: 'Цел',
      maxAge: 'Период',
    },
    goBack: 'Върни се назад',
  },
}
